"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PLACEHOLDER_IMAGE = exports.COLORS = exports.SIZES = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SIZES = ["small", "medium", "large", "xlarge"];
exports.SIZES = SIZES;
var COLORS = ["blue", "yellow", "coral", "teal"];
exports.COLORS = COLORS;
var PLACEHOLDER_IMAGE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
exports.PLACEHOLDER_IMAGE = PLACEHOLDER_IMAGE;

var Avatar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Avatar, _React$Component);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _possibleConstructorReturn(this, _getPrototypeOf(Avatar).apply(this, arguments));
  }

  _createClass(Avatar, [{
    key: "getColor",
    // 1 - use color prop
    // 2 - get a color based on user ID
    // 3 - random color from the list
    value: function getColor() {
      var _this$props = this.props,
          color = _this$props.color,
          user = _this$props.user;

      if (color) {
        return color;
      }

      if (user && user.id) {
        return COLORS[parseInt(user.id.slice(-4), 16) % COLORS.length];
      }

      return COLORS[Math.floor(Math.random() * COLORS.length)];
    }
  }, {
    key: "getInitials",
    value: function getInitials() {
      if (!this.props.user.first_name && !this.props.user.last_name) {
        return null;
      }

      var firstInitial = this.props.user.first_name.charAt(0).toUpperCase();

      if (this.props.user.first_name && !this.props.user.last_name) {
        return firstInitial;
      }

      var lastInitial = this.props.user.last_name.charAt(0).toUpperCase();
      return "".concat(firstInitial).concat(lastInitial);
    }
  }, {
    key: "getUserName",
    value: function getUserName() {
      return "".concat(this.props.user.first_name, " ").concat(this.props.user.last_name);
    }
  }, {
    key: "getAvatarStyles",
    value: function getAvatarStyles() {
      return "Avatar ".concat(this.props.size, " ").concat(this.getColor());
    }
  }, {
    key: "getImageUrl",
    value: function getImageUrl() {
      var srcSize = null;

      if (this.props.size === "small" || this.props.size === "medium") {
        srcSize = 50;
      } else if (this.props.size === "large" || this.props.size === "xlarge") {
        srcSize = 160;
      }

      var attrName = srcSize ? "image_url_".concat(srcSize) : "image_url";

      if (this.props.user[attrName]) {
        return this.props.user[attrName];
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var url = this.getImageUrl();

      if (url) {
        return _react.default.createElement("img", {
          className: this.getAvatarStyles(),
          src: this.getImageUrl(),
          alt: this.getUserName()
        });
      }

      var initials = this.getInitials();

      if (initials) {
        return _react.default.createElement("span", {
          className: this.getAvatarStyles()
        }, initials);
      }

      return _react.default.createElement("img", {
        className: "Avatar ".concat(this.props.size),
        src: PLACEHOLDER_IMAGE
      });
    }
  }]);

  return Avatar;
}(_react.default.Component);

Avatar.propTypes = {
  user: _propTypes.default.object,
  size: _propTypes.default.oneOf(SIZES),
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(COLORS), _propTypes.default.string])
};
Avatar.defaultProps = {
  user: {
    first_name: "",
    last_name: "",
    name: ""
  },
  size: "medium",
  color: ""
};
var _default = Avatar;
exports.default = _default;